type Wishlist = {
    display: boolean,
    wishListItems: number,
    url: string
}

export const defaultWishlist = {
    display: false,
    wishListItems: 0,
    url: ""
}

export default Wishlist;
